import { useEffect, useState } from "react";
import AddNewCreateUserLinkFormView from "./NewCreateUserLinkFormView/NewCreateUserLinkFormView";
import inputValidityChecker from "../../../../../utils/inputValidityChecker";
import { CreateUserLink, CreateUserLinkPatch } from "../../../types/createUserLink.type";
import useCreateUserLink from "../../../hooks/useCreateUserLink";
import {
  UserGender,
  UserRole,
  userRoles,
} from "../../../../user/types/user.types";
import { useAuth } from "../../../../auth/hooks";
import { Organization, OrganizationPatch } from "../../../../organization/types/organization.types";
import OrganizationPicker from "../../../../organization/components/OrganizationPicker/OrganizationPicker";
import { organizationAPI } from "../../../../organization/services/organizationAPI";

const BASE_URL_FRONT_LOGIN =
  process.env.REACT_APP_BASE_URL_FRONT + "/admin/new-account?token=";

export interface CreateUserLinkData {
  firstnameUser?: string;
  lastnameUser?: string;
  expiresIn?: string;
  emailUser?: string;
  userRole?: UserRole;
  userGender?: UserGender;
  organizationId?: string;
}

export interface ErrorStatus {
  isErrorFirstnameUser?: boolean;
  isErrorlLastnameUser?: boolean;
  isErrorExpiresIn?: boolean;
  isErrorUserRole?: boolean;
  isErrorOrganizationId?: boolean;
  isErrorEmailUser?: boolean;
  isGenderError?: boolean;
  allGood?: boolean;
  errorMessage?: string;
}

const INITIAL_FORM_DATA: CreateUserLinkData = {
  firstnameUser: "",
  lastnameUser: "",
  expiresIn: "",
  emailUser: "",
  userGender: "MALE",
  userRole: userRoles.USER,
};

const INITIAL_ERROR_STATUS: ErrorStatus = {
  isErrorFirstnameUser: false,
  isErrorlLastnameUser: false,
  isErrorExpiresIn: false,
  isErrorUserRole: false,
  isErrorOrganizationId: false,
  allGood: true,
  errorMessage: "",
};

/**
 * AddNewCreateUserLinkFormPresenter
 * @returns
 */
export default function AddNewCreateUserLinkFormPresenter({
  onSuccess,
  organizationId,
}: {
  onSuccess?: (result:CreateUserLink) => void;
  organizationId?: string;
}) {
  const { userRole, userLogged, organizationIdUser } = useAuth();

  const [formData, setFormData] = useState<CreateUserLinkData>({
    ...INITIAL_FORM_DATA,
    organizationId: organizationId,
  });
  const [errorStatus, setErrorStatus] = useState<ErrorStatus>({
    ...INITIAL_ERROR_STATUS,
  });

  const [messageError, setMessageError] = useState<string | null | undefined>(
    null
  );

  const [organization, setOrganization] = useState<OrganizationPatch | undefined>();

  const { createCreateUserLinkQuery } = useCreateUserLink({organizationId:organizationId});

 
  useEffect(() => {
    if (userRole && userRole < userRoles.SUPER_ADMIN) {
      setOrganization({
        organization_id : organizationIdUser,
      });
    }else{

    }
  }, [userLogged]);// eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (organizationId) {
      organizationAPI.getSingle(organizationId).then((response) => {
        setOrganization(response);
      }).catch((error) => {});
    }
  }, [organizationId]);
  if (!userRole) {
    return <>User not logged</>;
  }

  const handleSubmit = () => {
    const data = formDataConverter({...formData, 
      organizationId:  organization?.organization_id
    
    });
    const errorStatus = checkValidityForm(data, userRole);

    if (errorStatus.allGood) {
      createCreateUserLinkQuery.mutate({
        newData: data,
        callback: ({ result, error }) => {
          if (error) {
            setMessageError(error.message);
          }
          if (result) {
            onSuccess && onSuccess(result);
          }
        },
      });
    } else {
      setErrorStatus({ ...errorStatus });
      setMessageError(errorStatus.errorMessage);
    }
  };



  return (
    <AddNewCreateUserLinkFormView
      errorStatus={errorStatus}
      setFormData={setFormData}
      formData={formData}
      messageError={messageError}
      handleSubmit={handleSubmit}
      currentUserRoleCreator={userRole}
      organizationPickerComponent={<OrganizationPicker setOrganization={setOrganization} currentOrganization={organization as Organization} />}
    />
  );
}

const checkValidityForm = (
  data: CreateUserLinkPatch,
  userRole: UserRole
): ErrorStatus => {
  const errorStatus: ErrorStatus = {
    ...INITIAL_ERROR_STATUS,
  };

  let messageList = [];

  if (!inputValidityChecker.validateNotEmptyText(data.uct_firstname)) {
    errorStatus.isErrorFirstnameUser = true;
    messageList.push("Le prénom est obligatoire");
    errorStatus.allGood = false;
  }

  if (!inputValidityChecker.validateNotEmptyText(data.uct_lastname)) {
    errorStatus.isErrorlLastnameUser = true;
    messageList.push("Le nom est obligatoire");
    errorStatus.allGood = false;
  }

  /*
  if (!inputValidityChecker.validateNotEmptyText(data.uct_expired_at)) {
    errorStatus.isErrorExpiresIn = true;
    messageList.push("La date d'expiration est obligatoire");
    errorStatus.allGood = false;
  }
*/

  if (!inputValidityChecker.validateEmail(data.uct_email)) {
    errorStatus.isErrorEmailUser = true;
    messageList.push("L'email est invalide");
    errorStatus.allGood = false;
  }

  if (data.uct_user_role === undefined || data.uct_user_role === null) {
    errorStatus.isErrorUserRole = true;
    messageList.push("Le rôle est obligatoire");
    errorStatus.allGood = false;
  }

  if (
    userRole < userRoles.SUPER_ADMIN &&
    !inputValidityChecker.validateNotEmptyText(data.uct_organization_id)
  ) {
    messageList.push("organizationId est obligatoire");
    errorStatus.isErrorOrganizationId = true;
    errorStatus.allGood = false;
  }
  errorStatus.errorMessage = messageList.join(", ");
  return errorStatus;
};

const formDataConverter = (data: CreateUserLinkData): CreateUserLinkPatch => {
  return {
    uct_firstname: data.firstnameUser,
    uct_lastname: data.lastnameUser,
    uct_expired_at: data.expiresIn,
    uct_user_role: data.userRole,
    uct_organization_id: data.organizationId,
    uct_base_url: BASE_URL_FRONT_LOGIN,
    uct_email: data.emailUser,
    uct_user_gender: data.userGender,
  };
};
